import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {ImportadorIfoodService} from "../../services/importador-ifood.service";
import {PainelImportacaoProdutosComponent} from "../painel-importacao-produtos/painel-importacao-produtos.component";
import {ArmazenamentoService} from "../../services/armazenamento.service";
import {ModalKendo} from "../../lib/ModalKendo";
declare var moment;

@Component({
  selector: 'app-tela-sincronizar-ifood',
  templateUrl: './tela-sincronizar-ifood.component.html',
  styleUrls: ['./tela-sincronizar-ifood.component.scss']
})
export class TelaSincronizarIfoodComponent  extends ModalKendo implements OnInit {
  @Input() empresa: any;
  @ViewChild('frm', {static: false}) frm: NgForm;
  @ViewChild('painelImportacao', {static: false}) painelImportacao: PainelImportacaoProdutosComponent;
  catalogo: any = {};
  mensagemSucesso: any;
  mensagemErro: any;
  opcoes: any = { link: null, salvoLink: false};
  buscando = false;
  filtro: any;
  buscarProdutos: boolean
  buscouProdutos: boolean;
  tudoSincronizado: boolean;
  sincronizando: boolean;
  sincronizou: boolean;
  KEYLINKLOJA = '#linklojaifood'
  KEYLINKLOJAANOTAI = '#linklojaifood'
  empresaInfo: any;
  anotaAi = false;
  ifoodOficial = false;
  integracoesIfood: any[] = [];
  catalogosIfood: any[] = [];
  carregandoCatalogos = false;
  carregandoAdicionais = false;
  carregamentoAdicionais: any = {
    totalProdutos: 0,
    totalPaginas: 0,
    paginaAtual: 0,
    totalProcessados: 0,
    finalizado: false
  };
  statusCarregamentoAdicionais = '';
  constructor( private importador:  ImportadorIfoodService,
              private armazenamentoService: ArmazenamentoService) {
    super()

  }

  ngOnInit(): void {
   this.buscarProdutos = true

    if(this.ifoodOficial){
      this.integracoesIfood = (this.empresa && this.empresa.integracoesIfood)
        ? this.empresa.integracoesIfood.filter((item: any) => !item.desativado)
        : [];

      if(this.integracoesIfood.length === 1){
        this.opcoes.idLojaIfood = this.integracoesIfood[0].idLoja;
        this.onMudouIntegracaoIfood();
      }

      return;
    }

    if(!this.anotaAi){
      if(this.catalogo && this.catalogo.lojaIfood){
        this.opcoes.link = this.catalogo.lojaIfood;
      } else {
        let linkIfood = this.armazenamentoService.carregue(this.KEYLINKLOJA, false)

        if(linkIfood)
          this.opcoes.link = linkIfood;

      }
    } else {
      let linkAnotai = this.armazenamentoService.carregue(this.KEYLINKLOJAANOTAI, false)

      if(linkAnotai) this.opcoes.link = linkAnotai
    }


  }

  fecheMensagemErro() {
    delete this.mensagemErro;
  }

  fecheMensagemSucesso() {
    delete this.mensagemSucesso;
  }

  feche() {
    this.fecheModal(this.painelImportacao.importou)
  }

   async onBusqueProdutos() {
    if(this.buscando) return;

    delete this.mensagemErro;
    delete this.mensagemSucesso;
    delete this.tudoSincronizado;
    this.statusCarregamentoAdicionais = '';

    this.buscando = true;

    let resposta: any, keyBusca: string;

    if(!this.anotaAi){
      if(this.ifoodOficial){
        if(!this.opcoes.idLojaIfood || !this.opcoes.idCatalogoIfood){
          this.buscando = false;
          this.mensagemErro = 'Selecione a integração iFood e o catálogo oficial.';
          return;
        }

        resposta = await this.importador.listeNovosProdutosIfoodOficial(this.opcoes.idLojaIfood, this.opcoes.reducao,
          this.opcoes.sincronizarPrecos,
          this.opcoes.sincronizarImagens, this.opcoes.idCatalogoIfood).catch( erro => {
          this.buscando = false;
          this.mensagemErro = erro;
        });
      } else {
        keyBusca = this.KEYLINKLOJA;
        resposta = await this.importador.listeNovosProdutosIfood(this.opcoes.link, this.opcoes.reducao, this.opcoes.sincronizarPrecos,
          this.opcoes.sincronizarImagens).catch( erro => {
          this.buscando = false;
          this.mensagemErro = erro;
        });
      }

    } else {
      keyBusca = this.KEYLINKLOJAANOTAI;
      resposta = await this.importador.listeNovosProdutosAnotaAi(this.opcoes.link, this.opcoes.reducao, this.opcoes.sincronizarPrecos,
        this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    }

    if(resposta){
      this.buscouProdutos = true;
      this.empresaInfo   = resposta.empresaInfo;
      if(resposta.novosProdutos.length || resposta.produtosAtualizar.length){
        this.buscarProdutos = false;
        this.painelImportacao.setProdutosSincronizar(resposta.novosProdutos, resposta.produtosAtualizar, [],
          resposta.categorias)

        if(!this.anotaAi && !this.ifoodOficial){
          await this.carregueAdicionaisIfood(resposta.novosProdutos, resposta.produtosAtualizar);
        }
      } else {
        this.tudoSincronizado = true;
      }

      this.buscando = false;
      if(keyBusca)
        this.armazenamentoService.salveSemExpirar(keyBusca, this.opcoes.link)
    }
  }

  onFilter(texto: any){

  }

  obtenhaFormatoPercentual(){
    return String(`0"%"`);
  }

  sincronizarTodos() {

  }

  submitFormBusca() {
    this.frm.ngSubmit.emit()
  }

  importouProdutoDoIfood($event: any) {
    if(!this.opcoes.salvoLink && !this.anotaAi && !this.ifoodOficial){
      this.importador.salveLinkIfod(this.opcoes.link).then(() => {
        this.opcoes.salvoLink = true;
      });
    }
  }

  private async carregueAdicionaisIfood(novosProdutos: any[], produtosAtualizar: any[]) {
    const tamanhoPagina = 20;
    let todosProdutos = [...(novosProdutos || []), ...(produtosAtualizar || [])];
    let produtosComNeedChoices = todosProdutos.filter((produto: any) => produto && produto.needChoices && produto.idIfood);
    let idsUnicos = Array.from(new Set(produtosComNeedChoices.map((produto: any) => String(produto.idIfood))));

    if(!idsUnicos.length){
      this.carregandoAdicionais = false;
      this.carregamentoAdicionais = {
        totalProdutos: 0,
        totalPaginas: 0,
        paginaAtual: 0,
        totalProcessados: 0,
        finalizado: true
      };
      this.atualizeIndicadoresAdicionais();
      return;
    }

    this.carregandoAdicionais = true;
    this.statusCarregamentoAdicionais = 'Buscando adicionais dos produtos...';
    this.carregamentoAdicionais = {
      totalProdutos: idsUnicos.length,
      totalPaginas: Math.ceil(idsUnicos.length / tamanhoPagina),
      paginaAtual: 0,
      totalProcessados: 0,
      finalizado: false
    };

    for(let i = 0; i < idsUnicos.length; i += tamanhoPagina){
      let idsPagina = idsUnicos.slice(i, i + tamanhoPagina);
      this.carregamentoAdicionais.paginaAtual = Math.floor(i / tamanhoPagina) + 1;

      let carregouPagina = false;
      while(!carregouPagina){
        let resposta: any

        if(this.ifoodOficial){
          resposta =  await  this.importador.listeAdicionaisIfoodOficial(
            this.opcoes.idLojaIfood,
            idsPagina,
            this.opcoes.reducao,
            this.opcoes.idCatalogoIfood
          )
            .catch((erro: any) => {
              return this.deuErro(erro);
            });
        } else {
          resposta =  await  this.importador.listeAdicionaisProdutosIfood(this.opcoes.link, idsPagina, this.opcoes.reducao)
            .catch((erro: any) => {
              return this.deuErro(erro);
            });
        }

        if(!resposta){
          await this.sleep(5000);
          continue;
        }

        if(resposta && resposta.produtos){
          resposta.produtos.forEach((produtoComAdicional: any) => {
            let produto = todosProdutos.find((item: any) => String(item.idIfood) === String(produtoComAdicional.idIfood));
            if(produto)
              produto.camposAdicionais = produtoComAdicional.camposAdicionais || [];
          })
        }

        this.statusCarregamentoAdicionais = 'Buscando adicionais dos produtos...';
        carregouPagina = true;
      }

      this.carregamentoAdicionais.totalProcessados += idsPagina.length;
      this.atualizeIndicadoresAdicionais();

      let naoEhUltimaPagina = (i + tamanhoPagina) < idsUnicos.length;
      if(naoEhUltimaPagina)
        await this.sleep(8000);
    }

    this.carregandoAdicionais = false;
    this.carregamentoAdicionais.finalizado = true;
    this.statusCarregamentoAdicionais = '';
    this.atualizeIndicadoresAdicionais();
  }

  private deuErro(erro: any) {
    let detalhe = erro && erro.message ? erro.message : erro;
    this.mensagemErro = detalhe;
    this.statusCarregamentoAdicionais =
      `Lentidão na página ${this.carregamentoAdicionais.paginaAtual}/${this.carregamentoAdicionais.totalPaginas}. ` +
      `Tentar novamente da aqui a pouco... Vai demorar um pouco mais que previsto, aguarde e não feche essa tela.`;
    return null;
  }

  private atualizeIndicadoresAdicionais() {
    if(!this.painelImportacao || !this.painelImportacao.produtosSincronizarPorCategoria) return;

    this.painelImportacao.produtosSincronizarPorCategoria.forEach((categoria: any) => {
      categoria.produtos.forEach((produto: any) => {
        if(produto.sincronizar){
          const campos = produto.camposAdicionais || [];
          produto.qtdeAdicionaisNovos = campos.filter((adicional: any) => !adicional.id).length;
          produto.qtdeAdicionaisAtualizar = campos.filter((adicional: any) => adicional.id != null).length;
        }
      })
    })
  }

  private sleep(ms: number){
    return new Promise((resolve: any) => setTimeout(resolve, ms));
  }

  obtenhaPercentualCarregamentoAdicionais(){
    if(!this.carregamentoAdicionais || !this.carregamentoAdicionais.totalProdutos) return 0;
    return Math.round((this.carregamentoAdicionais.totalProcessados / this.carregamentoAdicionais.totalProdutos) * 100);
  }

  async onMudouIntegracaoIfood() {
    this.opcoes.idCatalogoIfood = null;
    this.catalogosIfood = [];
    if(!this.opcoes.idLojaIfood) return;

    this.carregandoCatalogos = true;
    delete this.mensagemErro;

    let catalogos: any[] = await this.importador.listeCatalogosIfoodOficial(this.opcoes.idLojaIfood).catch((erro) => {
      this.mensagemErro = erro;
      this.carregandoCatalogos = false;
    });

    if(catalogos){
      this.catalogosIfood = catalogos.map((catalogo: any) => {
        let descricao = catalogo.name  || catalogo.type || catalogo.context || catalogo.id;

        if(catalogo.modifiedAt)
            descricao = ` ${descricao} - Ultima alteraçao: ${moment(new Date(catalogo.modifiedAt)).format('DD/MMM/YY HH:mm')}`

        return { id: catalogo.catalogId, descricao: descricao};
      });

      if(this.catalogosIfood.length === 1)
        this.opcoes.idCatalogoIfood = this.catalogosIfood[0].id;
    }

    this.carregandoCatalogos = false;
  }
}
